import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function LandingHeader() {
  return (
    <header className="sticky top-0 z-50 glass-strong border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-4 flex items-center justify-between">
        <Link to="/" data-testid="header-brand" className="flex items-center gap-2">
          <Logo size="h-16 lg:h-20" hideText />
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-white/70">
          <a href="#features" className="hover:text-white">Features</a>
          <a href="#pricing" className="hover:text-white">Pricing</a>
          <a href="#testimonials" className="hover:text-white">Customers</a>
          <Link to="/pricing" className="hover:text-white">Plans</Link>
        </nav>
        <div className="flex items-center gap-3">
          <Link
            to="/login"
            data-testid="header-login-link"
            className="text-sm text-white/80 hover:text-white px-3 py-2"
          >
            Sign in
          </Link>
          <Link
            to="/register"
            data-testid="header-register-link"
            className="text-sm brand-gradient px-4 py-2 rounded-lg font-medium hover:opacity-90 transition glow-orange"
          >
            Get started
          </Link>
        </div>
      </div>
    </header>
  );
}
